module.exports = "/_next/static/images/9ac770c94bfa45a05e5b56d82c4c681b-nubanker-eng@2x.jpg";